import React, { useState } from 'react'
import CloseIco from '../../../assets/icons/close.png'
import {
    Chart as ChartJS,
    CategoryScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    RadarController,
    RadialLinearScale, } from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { useEffect } from 'react';
import { getScore } from '../../../helpers/getScore';


const SurveyRadarChart = ({ onClose, survey,modal }) => {

    ChartJS.register(
        CategoryScale,
        // LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend, PointElement, LineElement, RadarController, 
        RadialLinearScale

    );

    const [formattedAns, setFormattedAns] = useState([])



    useEffect(() => {
        let temp = []
        Object.values(survey.answers).forEach((a, id) => {
            if (id != 0) {
                temp.push(getScore(id, a))

            }
        })
        setFormattedAns(temp)
    }, [])

    return (
        <div style={{width:"90%",}} >

           {modal&& <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} >
                <h1>Radar Chart</h1>
                <img src={CloseIco} style={{ width: 25, height: 25, cursor: 'pointer' }} onClick={onClose} />


            </div>}
            <div  style={{ width: '100%', height: '100%' }}>
                <Radar
                   
                    options={{
                        responsive: true,
                        scales: {
                            y: {

                                display: true, // Hide Y axis labels

                            },
                            x: {
                                display: true // Hide X axis labels
                            }
                        },
                        plugins: {

                            legend: {
                                position: 'top',
                                display: false
                            },

                            title: {
                                display: false,
                                text: 'Chart.js Bar Chart',
                            },


                        },
                    }}
                    data={{
                        labels: ['Pain', 'Disability', 'Sleep', 'Stress/Anxiety', "Fear of Movement", 'Work Related Fear', 'Mood', 'Pain Beliefs', 'Work Beliefs'],
                        datasets: [
                            {
                                label: 'Dataset 1',
                                data: formattedAns,
                                backgroundColor: 'rgba(255, 99, 132, 0.5)',
                                barThickness: 20,

                            },

                        ],
                    }}
                />
            </div>
        </div>
    )
}

export default SurveyRadarChart